import React from 'react';
import { Outlet } from 'react-router-dom';
import SimpleHeader from '../components/SimpleHeader';
import GovernmentVerificationBanner from '../components/GovernmentVerificationBanner';
import TopBanner from '../components/TopBanner';

const DefaultLayout = () => {
  React.useEffect(() => {
    document.documentElement.lang = 'ar';
    document.documentElement.dir = 'rtl';
  }, []);

  return (
    <div className="min-vh-100 d-flex flex-column" dir="rtl">
      <header className="sticky top-0 z-50 bg-white shadow-sm">
        <GovernmentVerificationBanner />
        <TopBanner />
        <SimpleHeader />
      </header>

      <main className="flex-grow-1" style={{ background: 'var(--gray-50)' }}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DefaultLayout;
